module.exports = __webpack_public_path__ + "images/products/subscription-calendar-8b8fbff5.png";